import { render, staticRenderFns } from "./StclN_Details.vue?vue&type=template&id=52eaf3e5"
import script from "./StclN_Details.vue?vue&type=script&lang=js"
export * from "./StclN_Details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports